import PropTypes from "prop-types";
import React from "react";
import { Typography, Box, IconButton, TextField } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { UploadButton } from "../../components/Buttons";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles(theme => ({
  caption: {
    marginLeft: theme.spacing(2)
  },
  root: {
    color: theme.palette.text.secondary
  }
}));

const TextFieldUploadButton = ({
  onFileUpload,
  file,
  disabled,
  acceptType,
  icon,
  helperText,
  disableUnderline,
  error,
  multiple
}) => {
  const classes = useStyles();
  const inputRef = React.useRef();
  const { t } = useTranslation();

  const handleFileUpload = uploadedFile => {
    onFileUpload(uploadedFile);
  };
  const bottomMessage = (
    <Typography
      className={classes.caption}
      variant="caption"
      color={error ? "error" : "textSecondary"}
    >
      {error ? error : helperText}
    </Typography>
  );
  return (
    <div className={classes.root}>
      {file && (
        <div>
          <Box ml={-1} display="flex" alignItems="center">
            <UploadButton
              buttonVariant="text"
              buttonText={file.name}
              acceptType={acceptType}
              icon={icon}
              buttonId="reupload-file"
              labelVariant="body1"
              onUpload={ev => {
                handleFileUpload(ev.target.files[0]);
              }}
              disabled={disabled}
            />
            <IconButton
              color="primary"
              onClick={() => handleFileUpload(null)}
              disabled={disabled}
              size="large"
            >
              <CloseIcon />
            </IconButton>
          </Box>
          {error && bottomMessage}
        </div>
      )}
      {!file && (
        <>
          <div>
            <TextField
              type="button"
              value={t("textFieldUploadButton.buttonLabel")}
              variant="filled"
              fullWidth
              error={!!error}
              disabled={disabled}
              InputProps={{
                disableUnderline
              }}
              onClick={ev => {
                inputRef.current.click();
              }}
              hiddenLabel
            />
            <input
              style={{ display: "none" }}
              accept={acceptType}
              multiple={multiple}
              id="upload-file"
              type="file"
              ref={inputRef}
              onChange={ev => {
                if (multiple) {
                  handleFileUpload(Array.from(ev.target.files));
                } else {
                  handleFileUpload(ev.target.files[0]);
                }
              }}
            />
          </div>
          {bottomMessage}
        </>
      )}
    </div>
  );
};

export default TextFieldUploadButton;

TextFieldUploadButton.propTypes = {
  /**
   * If true, disables the file upload button
   */
  disabled: PropTypes.bool,
  /**
   * The currently uploaded file
   */
  file: PropTypes.any,
  /**
   * Called when the user uploads a file
   */
  onFileUpload: PropTypes.func,
  multiple: PropTypes.bool
};

TextFieldUploadButton.defaultProps = {
  disableUnderline: true,
  acceptType: "*",
  multiple: false
};
